import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import UITextInput from 'UIComponents/input/UITextInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import { SocialMediaSlugs } from '../consts';
import SocialIcon from './Icons/SocialIcon';
import styled from './Theme';
const inputSocialMap = {
  linkedinId: 'linkedin',
  twitterId: 'twitter',
  githubId: 'github',
  meetingsId: 'meetings'
};
const SocialFormControl = styled(UIFormControl).withConfig({
  displayName: "SocialInput__SocialFormControl",
  componentId: "gzmu3b-0"
})(["width:100%;"]);

const SocialInput = ({
  name,
  value,
  onChange
}) => {
  const socialMediaName = inputSocialMap[name];
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "row",
    align: "center",
    className: "m-bottom-6",
    children: [/*#__PURE__*/_jsx(SocialIcon, {
      className: "m-right-2",
      socialMediaName: socialMediaName
    }), /*#__PURE__*/_jsx(SocialFormControl, {
      children: /*#__PURE__*/_jsx(UIInputStaticLabel, {
        text: SocialMediaSlugs[socialMediaName],
        children: /*#__PURE__*/_jsx(UITextInput, {
          name: name,
          value: value,
          onChange: onChange,
          use: "on-dark"
        })
      })
    })]
  });
};

export default SocialInput;